<div class="login-main-container">
  <div class="login-side-logo" *ngIf="!isTabView">
     <img
      appPrependUrl
      src="/assets/images/transparent-home-login.png"
      alt="MyGooru Logo"
      class="logo"
    />
  </div>
  <div class="forgotPassword-container">
    <div (click)="goBack()" *ngIf="!isTabView" class="back-button-container">
      <img class="back-button" appPrependUrl src="/assets/icons/arrow-back.svg" alt="arrow-back" />
    </div>
    <div>
      <div class="login-img-container">
        <div class="illustration-container">
          <img appPrependUrl src="/assets/images/myg-mobile-profile.svg" alt="Learning Illustration" />
        </div>
        <span class="forgotPassword-label">Forgot password?</span>
        <form [formGroup]="form">
          <div class="input-wrapper">
            <div class="input-visibility">
              <input id="email" type="email" [(ngModel)]="emailVal" [formControlName]="'email'" name="email"
                (keydown)="onKeyDown($event)" placeholder="Enter your email" />
            </div>
            <div class="email-required-contain" *ngIf="
              (emailControl?.invalid &&
              (emailControl?.dirty || emailControl?.touched)
            ) && submitted">
              <span>Enter Valid Email</span>
            </div>
          </div>
        </form>
        <button class="submit-button" *ngIf="!resetMailsent" (click)="submitForm()">Submit</button>
        <div class="confirmation-container" *ngIf="resetMailsent && !userNotFound">
          <div class="icon">
            <img appPrependUrl src="/assets/icons/mail-box.svg"/>
          </div>
          <div class="message-content">
            <p class="confirmation-text">Reset link sent. Please check your email.</p>
          </div>
        </div>
        <span class="mail-sent error-message" *ngIf="userNotFound">User not found. Please check the email</span>
      </div>
    </div>
  </div>
</div>